import { AnyAction } from "redux";
import {
  REQUEST_FETCH_SUB_SKYAIR,
  REQUEST_FETCH_SUB_SKYAIR_ERROR,
  REQUEST_FETCH_SUB_SKYAIR_SUCCESS,
} from "redux/actions/general/subSkyAir";

const defaultState = {
  data: null,
  error: null,
  loading: false,
};

export default (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case REQUEST_FETCH_SUB_SKYAIR:
      return {
        ...state,
        loading: true,
      };
    case REQUEST_FETCH_SUB_SKYAIR_SUCCESS:
      return {
        data: action.subSkyAir,
        error: null,
        loading: false,
      };
    case REQUEST_FETCH_SUB_SKYAIR_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};
